export const userData = [
    {
        id: '17737d',
        name: "Phoenix Baker",
        
    },
    {
        id: '27737d',
        name: "Olivia Rhye",
    },
    {
        id: '37737d',
        name: "Lana Steiner",
    },
    {
        id: '47737d',
        name: "Demi Wilkinson",
    },
    {
        id: '47737d',
        name: "Natali Craig",
    },
    {
        id: '57737d',
        name: "Candice Wu",
    },
    {
        id: '67737d',
        name: "Drew Cano",
    },

]

/**
 * 
    "Olivia Rhye",
    "Lana Steiner",
    "Demi Wilkinson",
    "Candice Wu",
    "Natali Craig",
    "Drew Cano",
 */